import React from "react";
import Skeleton from "@mui/material/Skeleton";

const CountCardSkeleton = () => {
  return (
    <div className="row g-3 mb-4">
      {[...Array(4)].map((_, rowIndex) => (
        <div key={rowIndex} className="col-md-3 d-flex">
          <div
            className={`border rounded-3  d-flex flex-column h-100 w-100 text-dark`}
            role="button"
            style={{ cursor: "pointer" }}
          >
            <div className="d-flex justify-content-between px-3 py-3 align-items-center bg-white rounded-3">
              <div>
                <p className={`mb-1 fw-light`}>
                  <Skeleton width={100} />
                </p>
                <p className={`mb-0 fs-3 fw-bold `}>
                  <Skeleton width={130} />
                </p>
              </div>
              <div>
                <Skeleton width={60} height={60} />
              </div>
            </div>
            <div
              className="d-flex mt-auto px-3 py-2 rounded-bottom bg-opacity-10"
              style={{ backgroundColor: "rgba(232, 238, 255, 0.3)" }}
            >
              <p className="mb-0 fs-7 fst-italic fw-light w-100">
                <Skeleton width="100%" />
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CountCardSkeleton;
